<template>
  <div class="revenue-container">
    <div class="revenue-summary">
      <div class="summary-row">
        <span class="summary-label">{{ $t("globals.based_on_contract_duration") }}:</span>
        <span class="summary-value">
          <icon v-if="loading" name="spinner" spin></icon>
          <span v-else class="value-text success">{{
            currencyFormat(value_signed)
          }}</span>
        </span>
      </div>
      <div class="summary-row">
        <span class="summary-label">{{ $t("globals.based_on_average_contract_length") }}:</span>
        <span class="summary-value">
          <icon v-if="loading" name="spinner" spin></icon>
          <span v-else class="value-text success">{{
            currencyFormat(value_auto)
          }}</span>
        </span>
      </div>
      <div class="summary-row total">
        <span class="summary-label">{{ $t("globals.total") }}:</span>
        <span class="summary-value">
          <icon v-if="loading" name="spinner" spin></icon>
          <span v-else class="value-text success">{{
            currencyFormat(value_signed + value_auto)
          }}</span>
        </span>
      </div>
    </div>
    <div class="date-picker-wrapper">
      <ulu-date-picker
        range
        :not-before="Date.now()"
        v-model="range"
        lang="en"
        format="DD.MM.YYYY"
        :placeholder="$t('globals.select_range')"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import { currencyFormat } from "@/helpers/price";

import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "ulu-date-picker": DatePicker
  },
  data() {
    return {
      range: [null, null],
      value_signed: 0,
      value_auto: 0,
      loading: false
    };
  },
  methods: {
    ...mapActions(["fetchFutureRevenue"]),
    currencyFormat,
    fetchData(range) {
      this.loading = true;

      this.fetchFutureRevenue(range)
        .then(res => {
          this.value_signed = res.data.data.futureRevenue[0];
          this.value_auto = res.data.data.futureRevenue[1];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clean() {
      this.value = 0;
    }
  },
  computed: {
    ...mapGetters(["getUserSystem"])
  },
  watch: {
    range: function(newRange) {
      if (newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        const range = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];

        this.fetchData(range);
      } else {
        this.clean();
      }
    },
    getUserSystem: function() {
      this.range = [null, null];
      this.clean();
    }
  }
};
</script>

<style scoped>
.revenue-container {
  padding: 0;
}

.revenue-summary {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background-color: #f7fafc;
  border-radius: 8px;
  border-left: 4px solid #28a745;
}

.summary-row.total {
  border-left-color: #17a2b8;
  background-color: #e7f7f9;
}

.summary-label {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #6c757d;
  flex: 1;
}

.summary-value {
  display: flex;
  align-items: center;
  gap: 8px;
}

.value-text {
  font-size: 1.25rem;
  font-weight: 700;
}

.value-text.success {
  color: #28a745;
}

.summary-row.total .value-text {
  color: #17a2b8;
}

.date-picker-wrapper {
  margin-top: 16px;
}

.date-picker-wrapper >>> .mx-datepicker {
  width: 100%;
}

.date-picker-wrapper >>> .mx-input {
  height: 40px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  padding: 8px 12px;
  font-size: 0.9375rem;
}
</style>
